<template>
  <v-menu v-model="menu" :left="left" :close-on-content-click="false" transition="scale-transition" offset-y
          :max-width="$isMobile ? 300 : 450">
    <template v-slot:activator="{ on }">
      <v-text-field style='background: #ffffff' ref="input" v-bind="$attrs" v-model="currentValue"
                    :height="textHeight"
                    :class="{ required: required }"
                    :outlined="outlined" required :rules="required ? rules : []" dense hide-details :error="error"
                    readonly
                    v-on="on" :placeholder='placeholder' :disabled="disabled" clearable></v-text-field>
    </template>
    <v-card>
      <div class="date-time-title px-4 py-2 title d-flex primary white--text font-weight-bold">
        <div>{{ date ? moment(date).format('YYYY/MM/DD') : '--/--/--' }}</div>
        &nbsp;
        <div>{{ hour ? hour : '--' }}:{{ minute ? minute : '--' }}</div>
      </div>
      <div class="mobile-date-main" v-if="$isMobile">
        <v-date-picker v-model="date" @change="dateChange" :min="min" :max="max" no-title></v-date-picker>
        <div class="d-flex align-start justify-space-around time-card v-date-picker-table--date">
          <div>
            <div>Hour</div>
            <div>
              <div v-for="(items, row) in hourList" class="d-flex" :key="row">
                <div v-for="(item, col) in items" cols="2" class="text-center" :key="col" style="flex: 1">
                  <v-btn :disabled="Number(item) < Number(minHour)" @click="hour = item" text fab
                         class="mx-1 clendar-btn-text" small
                         :class="{ primary: hour === item }">{{ item }}
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div>Minute</div>
            <div>
              <div v-for="(items, row) in minuteList" class="d-flex" :key="row">
                <div v-for="(item, col) in items" cols="2" class="text-center" :key="col" style="flex: 1">
                  <v-btn :disabled="Number(item) < Number(minMinute)" @click="minute = item" text fab
                         class="mx-1 clendar-btn-text"
                         :class="{ primary: minute === item }">
                    {{ item }}
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="d-flex">
        <v-date-picker v-model="date" @change="dateChange" :min="min" :max="max" no-title></v-date-picker>
        <v-divider vertical class="mx-2 my-2"></v-divider>
        <div class="mt-3 px-3 time-card v-date-picker-table--date">
          <div>Hour</div>
          <div>
            <div v-for="(items, row) in hourList" class="d-flex" :key="row">
              <div v-for="(item, col) in items" cols="2" class="text-center" :key="col" style="flex: 1">
                <v-btn :disabled="Number(item) < Number(minHour)" @click="hour = item" text fab
                       class="mx-1 clendar-btn-text" small
                       :class="{ primary: hour === item }">{{ item }}
                </v-btn>
              </div>
            </div>
          </div>
          <div>Minute</div>
          <div>
            <div v-for="(items, row) in minuteList" class="d-flex" :key="row">
              <div v-for="(item, col) in items" cols="2" class="text-center" :key="col" style="flex: 1">
                <v-btn :disabled="Number(item) < Number(minMinute)" @click="minute = item" text fab
                       class="mx-1 clendar-btn-text"
                       :class="{ primary: minute === item }">
                  {{ item }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-card-actions class="justify-end">
        <v-btn :disabled="!date || !hour || !minute" color="primary" small @click="confirm">
          {{ language === 'chinese' ? '确认' : 'Confirm' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    placeholder: {
      value: {
        type: String,
        default: '',
      },
    },
    language: {
      type: String,
      default: 'chinese',
    },
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    default: {
      type: String,
      default: '',
    },
    rules: {
      default: () => {
        return [v => !!v || '']
      },
    },
    left: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    min: {
      type: String,
      default: '',
    },
    max: {
      type: String,
      default: '',
    },
    minTime: {
      type: Date,
      default: null,
    },
    maxTime: {
      type: Date,
      default: null,
    },
    textHeight: {
      type: Number,
      default: 40,
    },
  },
  inject: {
    form: {
      default: null,
    },
  },
  data() {
    return {
      menu: false,
      hourList: [
        // ['00', '01', '02', '03'],
        // ['04', '05', '06', '07'],
        ['08', '09', '10'],
        ['11', '12', '13'],
        // [, ],
        ['14', '15', '16'],
        ['17', '18', '19'],
        ['20', '21', '22'],
      ],
      minuteList: [
        ['00', '10', '20'],
        ['30', '40', '50'],
      ],
      date: '',
      hour: '',
      minute: '',
      minHour: '',
      minMinute: '',
      moment,
    }
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  created() {
    this.form && this.form.register(this)
  },
  beforeDestroy() {
    this.form && this.form.unregister(this)
  },
  watch: {
    menu(newValue, oldValue) {
      if (newValue) {
        if (this.value) {
          this.setData(this.value)
        } else if (this.default) {
          this.setData(this.default)
        }
      }
    },
    date(newValue, oldValue) {
      this.resetValidation()
    },
    hour(newValue, oldValue) {
      this.resetValidation()
    },
    minute(newValue, oldValue) {
      this.resetValidation()
    },
  },
  methods: {
    /** @public */
    reset() {
      return this.$refs.input.reset()
    },

    /** @public */
    resetValidation() {
      return this.$refs.input.resetValidation()
    },

    /** @public */
    validate(force = false, value) {
      return this.$refs.input.validate()
    },
    setData(value) {
      if (value) {
        const inputDate = moment(value)
        this.date = inputDate.format('YYYY-MM-DD')
        this.hour = inputDate.format('HH')
        this.minute = inputDate.format('mm')
      }
    },
    confirm() {
      this.$emit('input', `${this.date} ${this.hour}:${this.minute}:00`)
      this.$emit('changeDate')
      this.menu = false
    },
    dateChange(val) {
      this.hour = ''
      this.minute = ''
      if (this.minTime && val) {
        const minDate = moment(moment(this.minTime).format('YYYY-MM-DD'))
        const diff = minDate.valueOf() - moment(val).valueOf()
        if (diff < 0) {
          this.minHour = ''
          this.minMinute = ''
        } else {
          this.minHour = String(moment(this.minTime).hours())
          this.minMinute = String(moment(this.minTime).minutes() - 10)
        }
      }
      this.$emit('changeDate', val)
    },
  },
}
</script>

<style lang="scss" scoped>
.time-card {
  color: #5e5669de !important;
}

::v-deep .mobile-date-main .v-date-picker-table {
  height: 215px;
}

.clendar-btn-text {
  font-size: 12px;
  // color: #5e5669de !important;
  width: 30px;
  height: 30px;
}
</style>
